import { useQuery } from "@tanstack/react-query";
import { apiGet } from "@/lib/apiClient";
import type { DashboardDataResponse } from "@/types/dashboard";

export const dashboardKeys = {
  details: (isDashboardBusinessFilter: boolean, businessName: string | null, fyId: number) =>
    ["dashboard", "details", isDashboardBusinessFilter, businessName, fyId] as const,
  businesses: () => ["dashboard", "businesses"] as const
};

export function useDashboardData(
  isDashboardBusinessFilter: boolean,
  businessName: string | null,
  fyId: number
) {
  return useQuery({
    queryKey: dashboardKeys.details(isDashboardBusinessFilter, businessName, fyId),
    enabled: fyId > 0,
    queryFn: () => {
      const base = `Dashboard/dashboard/${isDashboardBusinessFilter}/${fyId}`;
      const path =
        businessName != null
          ? `${base}?businessName=${encodeURIComponent(businessName)}`
          : base;
      return apiGet<DashboardDataResponse>(path);
    },
    placeholderData: (previousData) => previousData,
    staleTime: 60_000,
    refetchOnMount: "always"
  });
}


export function useBusinesses() {
  return useQuery({
    queryKey: dashboardKeys.businesses(),
    queryFn: () =>
      apiGet<Record<string, string[]>>("Business/GetBusinessAndBusinessLineTypes"),
    staleTime: 5 * 60_000,
    refetchOnMount: "always"
  });
}

export interface GrcDashBoardChartResponse {
  occupancyByMeetingCategory: { label: string; value: number; color?: string }[];
  occupancyByMeetingType: { label: string; value: number; color?: string }[];
  occupancyAttritionByPeriod: { period: number; inventory: number; occupancyPct: number; attritionPct: number }[];
  occupancyByBusinessByPeriod: { period: number; values: Record<string, number> }[];
  forecastPeriods: { periodNumber: number; periodLabel: string; inventory: number; occupancyPct: number; attritionPct: number; bookedDays: number; actualDays: number }[];
  lastUpdated: string;
}

export function useGrcDashboardChart(fyId: number) {
  return useQuery({
    queryKey: ["grc-dashboard-chart", fyId] as const,
    enabled: fyId > 0,
    queryFn: () => apiGet<GrcDashBoardChartResponse>(`Dashboard/grc-dashboard-chart/${fyId}`),
    staleTime: 60_000,
    refetchOnMount: "always",
  });
}

// export async function useBusinesses(): Promise<Record<string, string[]> | undefined> {
//   return apiGet<Record<string, string[]>>(`Business/GetBusinessAndBusinessLineTypes`);
// }


